export default {"id":"8f3ce995","attrs":{"viewBox":"0 0 512 512","width":"512","height":"512"}}